import { render } from "./IncentivesIcon.vue?vue&type=template&id=d17aa3ca"
import script from "./IncentivesIcon.vue?vue&type=script&lang=js"
export * from "./IncentivesIcon.vue?vue&type=script&lang=js"
script.render = render

export default script